import { Xmark } from '@gravity-ui/icons';
import { Button, Sheet } from '@gravity-ui/uikit';

import { CANCEL, CONFIRMATION_DELETE, DELETE, DELETE_QUESTION } from 'features/admin-mode/constants';

import styles from './styles.module.scss';

export const DeleteSheet = ({ open, setOpen, removeSection, id }: any) => {
	return (
		<Sheet visible={open} onClose={() => setOpen(false)} className={styles.sheet} title={CONFIRMATION_DELETE}>
			<div className={styles.sheet__close}>
				<Button view="flat">
					<Xmark onClick={() => setOpen(false)} cursor="pointer" />
				</Button>
			</div>
			<div className={styles.sheet__content}>{DELETE_QUESTION}</div>
			<div className={styles.sheet__btns}>
				<Button
					onClick={() => {
						removeSection(id);
						setOpen(false);
					}}
					size="xl"
					view="outlined-danger"
				>
					{DELETE}
				</Button>
				<Button onClick={() => setOpen(false)} size="xl" view="flat">
					{CANCEL}
				</Button>
			</div>
		</Sheet>
	);
};
